import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children, portalRoute = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F5]">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-[#2D5A4C]" />
          <p className="text-[#5E6D66]">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={portalRoute ? "/portail" : "/login"} replace />;
  }

  // Portal routes: only allow membre_externe
  if (portalRoute && user.role !== 'membre_externe') {
    return <Navigate to="/dashboard" replace />;
  }

  // CRM routes: block membre_externe from internal CRM
  if (!portalRoute && user.role === 'membre_externe') {
    return <Navigate to="/portail/dashboard" replace />;
  }

  return children;
}
